import fireErrorAnalytics from '@atlassian/jira-errors-handling/src/utils/fire-error-analytics.tsx';
import { performGetRequest } from '@atlassian/jira-fetch/src/utils/requests.tsx';
import type { TemplateForm } from '@atlassian/proforma-common-core/form-system-models';
import { packageName, teamName } from '../../common/constants.tsx';
import type { FetchProformaFormDataParams } from './types.tsx';

export const fetchProformaFormData = async ({
	cloudId,
	projectId,
	formId,
}: FetchProformaFormDataParams): Promise<TemplateForm | null> =>
	performGetRequest(
		`/gateway/api/proforma/cloudid/${cloudId}/api/2/projects/${projectId}/forms/${formId}`,
	);

export const sendErrorAnalyticsEvent = (projectId: number, formId: number, error: Error) => {
	fireErrorAnalytics({
		meta: {
			id: 'fetchProformaReqTypeForm',
			packageName,
			teamName,
		},
		error,
		attributes: {
			projectId,
			formId,
		},
	});
};
